import React, { FC, Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';
import { IntercomProvider } from 'react-use-intercom';
import { ToastContainer, Zoom } from 'react-toastify';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import Routes from './Routes';
import MobileDetect from 'components/auth/MobileDetect';
import { UserContextProvider } from './components/context/UserContext';
import { ViboThemeProvider } from './components/context/ViboThemeContext';
import { IntercomContextProvider } from './components/context/IntercomContext';

import { INTERCOM_APP_ID } from './services/constants';

import client from './graphql/client';
import './utils/mixpanel';

const App: FC = () => (
  <ApolloProvider client={client}>
    <Suspense fallback={<div />}>
      <IntercomProvider appId={INTERCOM_APP_ID}>
        <UserContextProvider>
          <ViboThemeProvider>
            <IntercomContextProvider>
              {/* <DND.Provider> */}
              <MobileDetect>
                <QueryParamProvider adapter={ReactRouter6Adapter}>
                  <Routes />
                </QueryParamProvider>
              </MobileDetect>
              {/* </DND.Provider> */}
            </IntercomContextProvider>
          </ViboThemeProvider>
        </UserContextProvider>
      </IntercomProvider>
    </Suspense>
    <ToastContainer limit={1} transition={Zoom} />
  </ApolloProvider>
);

export default App;
